'use client';
import React, { useState, useEffect, useRef } from 'react';

const tabs = [
  {
    id: 'catalogo',
    label: 'Catálogo digital',
    tag: 'INCLUIDO EN AMBOS PLANES',
    tagColor: '#C8102E',
    tagBg: 'rgba(200,16,46,0.12)',
    h3: 'Tu concesionario en línea en minutos',
    body: 'Un catálogo premium con filtros dinámicos, galería de fotos, ficha técnica descargable y botón de WhatsApp en cada vehículo.',
    bullets: ['Filtros por marca, año, precio y tipo', 'Botón WhatsApp con mensaje pre-diligenciado', 'Vista detallada con galería y especificaciones completas'],
    cta: 'Ver demo del catálogo',
    ctaTarget: 'demo',
    mockup: 'catalog',
  },
  {
    id: 'pipeline',
    label: 'Pipeline de ventas',
    tag: 'SOLO EN PLAN PRO',
    tagColor: '#C8102E',
    tagBg: 'rgba(200,16,46,0.12)',
    h3: 'Sabe exactamente dónde está cada vehículo',
    body: 'Desde que entra al inventario hasta que se entrega al cliente — cada etapa visible, cada acción registrada.',
    bullets: ['5 etapas: Inventario → Reservado → Negociando → Vendido → Entregado', 'Badges Hot / Warm / Cold por prospecto', 'Un clic para marcar como vendido y eliminar del catálogo automáticamente'],
    cta: 'Empieza gratis 14 días',
    ctaTarget: 'pricing',
    mockup: 'pipeline',
  },
  {
    id: 'crm',
    label: 'CRM de clientes',
    tag: 'SOLO EN PLAN PRO',
    tagColor: '#C8102E',
    tagBg: 'rgba(200,16,46,0.12)',
    h3: 'Cada cliente. Cada conversación. Un solo lugar.',
    body: 'Historial completo de interacciones, seguimientos programados y análisis de dónde vienen tus mejores clientes.',
    bullets: ['Perfil completo por cliente con historial de actividad', 'Fuente de origen: Walk-in, Instagram, Website, Referido, WhatsApp', 'Temperatura del prospecto: caliente, tibio, frío'],
    cta: 'Ver el CRM en acción',
    ctaTarget: 'demo',
    mockup: 'crm',
  },
  {
    id: 'finanzas',
    label: 'Finanzas en tiempo real',
    tag: 'SOLO EN PLAN PRO',
    tagColor: '#C8102E',
    tagBg: 'rgba(200,16,46,0.12)',
    h3: 'Margen, ingresos y capital — siempre visibles.',
    body: 'No más finales de mes sorpresivos. Sabe exactamente cuánto ganaste, qué vehículo es más rentable y cuánto capital tienes inmovilizado en inventario.',
    bullets: ['KPIs en tiempo real: ingresos, margen bruto, capital en inventario', 'Margen por unidad vendida, codificado por colores', 'Rendimiento por categoría: SUV, Pickup, Can-Am, Sea-Doo'],
    cta: 'Empieza gratis 14 días',
    ctaTarget: 'pricing',
    mockup: 'finance',
  },
  {
    id: 'pdf',
    label: 'Ficha técnica PDF',
    tag: 'DISPONIBLE EN AMBOS PLANES',
    tagColor: '#888888',
    tagBg: 'rgba(136,136,136,0.12)',
    h3: 'Fichas técnicas profesionales en un clic.',
    body: 'Genera un PDF imprimible con todas las especificaciones del vehículo, tu logo, precio y datos de contacto. Listo para enviar por WhatsApp.',
    bullets: ['Ficha pública para clientes (sin costos ni VIN)', 'Ficha confidencial interna con costo, margen y VIN (solo Plan Pro)', 'Logo de tu concesionario en cada ficha'],
    cta: 'Ver ejemplo de ficha',
    ctaTarget: 'demo',
    mockup: 'pdf',
  },
];

function CatalogMockup() {
  const vehicles = [
    { brand: 'PORSCHE', name: 'Cayenne S 2024', price: '$890.000.000' },
    { brand: 'BMW', name: 'X5 xDrive40i', price: '$620.000.000' },
    { brand: 'RANGE ROVER', name: 'Sport HSE 2024', price: '$780.000.000' },
    { brand: 'RAM', name: '1500 Laramie 2024', price: '$320.000.000' },
  ];
  return (
    <div style={{ background: '#111111', borderRadius: '10px', padding: '20px', borderTop: '3px solid #C8102E' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '11px', color: '#C8102E', letterSpacing: '0.1em' }}>CATÁLOGO ACTIVO</span>
        <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 600, fontSize: '10px', color: '#888888' }}>4 vehículos</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        {vehicles.map((v, i) => (
          <div key={i} style={{ background: '#1A1A1A', borderRadius: '6px', overflow: 'hidden' }}>
            <div style={{ height: '70px', background: '#2A2A2A', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ color: '#555555', fontSize: '10px', fontFamily: 'Montserrat, sans-serif' }}>📷 Foto</span>
            </div>
            <div style={{ padding: '8px' }}>
              <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '9px', color: '#C8102E', letterSpacing: '0.1em' }}>{v.brand}</div>
              <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 600, fontSize: '11px', color: '#FFFFFF', marginTop: '2px' }}>{v.name}</div>
              <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '11px', color: '#C8102E', marginTop: '4px' }}>{v.price}</div>
              <div style={{ display: 'flex', gap: '4px', marginTop: '6px' }}>
                <button style={{ flex: 1, background: '#C8102E', color: '#FFF', border: 'none', borderRadius: '3px', fontSize: '8px', padding: '4px', fontFamily: 'Montserrat, sans-serif', fontWeight: 700, cursor: 'pointer' }}>Ver más</button>
                <button style={{ flex: 1, background: '#25D366', color: '#FFF', border: 'none', borderRadius: '3px', fontSize: '8px', padding: '4px', fontFamily: 'Montserrat, sans-serif', fontWeight: 700, cursor: 'pointer' }}>WhatsApp</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function PipelineMockup() {
  const stages = [
    { name: 'Inventario', color: '#888888', cards: ['Cayenne S', 'X5 2024'] },
    { name: 'Reservado', color: '#3B82F6', cards: ['Range Rover'] },
    { name: 'Negociando', color: '#F59E0B', cards: ['RAM 1500', 'Hilux GR'] },
    { name: 'Vendido', color: '#10B981', cards: ['Maverick X3'] },
    { name: 'Entregado', color: '#C8102E', cards: ['Sea-Doo RXP'] },
  ];
  return (
    <div style={{ background: '#111111', borderRadius: '10px', padding: '16px', borderTop: '3px solid #C8102E', overflowX: 'auto' }}>
      <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '11px', color: '#C8102E', letterSpacing: '0.1em', marginBottom: '12px' }}>PIPELINE DE VENTAS</div>
      <div style={{ display: 'flex', gap: '8px', minWidth: '480px' }}>
        {stages.map((stage) => (
          <div key={stage.name} style={{ flex: 1, background: '#1A1A1A', borderRadius: '6px', padding: '8px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '8px' }}>
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: stage.color, display: 'inline-block' }} />
              <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '8px', color: '#CCCCCC', textTransform: 'uppercase' }}>{stage.name}</span>
            </div>
            {stage.cards.map((card) => (
              <div key={card} style={{ background: '#222222', borderRadius: '4px', padding: '6px 8px', marginBottom: '4px' }}>
                <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 600, fontSize: '9px', color: '#FFFFFF' }}>{card}</div>
                <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '7px', color: stage.color === '#F59E0B' ? '#F59E0B' : '#C8102E', background: stage.color === '#F59E0B' ? 'rgba(245,158,11,0.1)' : 'rgba(200,16,46,0.1)', padding: '1px 4px', borderRadius: '2px' }}>
                  {stage.color === '#F59E0B' ? 'HOT' : 'WARM'}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

function CRMMockup() {
  return (
    <div style={{ background: '#111111', borderRadius: '10px', padding: '16px', borderTop: '3px solid #C8102E' }}>
      <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '11px', color: '#C8102E', letterSpacing: '0.1em', marginBottom: '12px' }}>CRM — PERFIL DE CLIENTE</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
        <div style={{ background: '#1A1A1A', borderRadius: '6px', padding: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
            <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#C8102E', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '12px', color: '#FFF' }}>CM</div>
            <div>
              <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '11px', color: '#FFFFFF' }}>Carlos M.</div>
              <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '9px', color: '#888888' }}>Instagram · 🔥 Caliente</div>
            </div>
          </div>
          {[['Interés', 'Cayenne S 2024'], ['Presupuesto', '$900M COP'], ['Seguimiento', 'Mañana 10am']].map(([k, v]) => (
            <div key={k} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
              <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '9px', color: '#888888' }}>{k}</span>
              <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 600, fontSize: '9px', color: '#CCCCCC' }}>{v}</span>
            </div>
          ))}
        </div>
        <div style={{ background: '#1A1A1A', borderRadius: '6px', padding: '12px' }}>
          <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '9px', color: '#888888', textTransform: 'uppercase', marginBottom: '8px' }}>Actividad reciente</div>
          {[
            { time: 'Hoy 9:15', text: 'Llamada — interesado en prueba' },
            { time: 'Ayer 14:30', text: 'WhatsApp — envió ficha PDF' },
            { time: 'Lun 11:00', text: 'Walk-in — primera visita' },
          ].map((item, i) => (
            <div key={i} style={{ borderLeft: '2px solid #C8102E', paddingLeft: '8px', marginBottom: '8px' }}>
              <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 600, fontSize: '8px', color: '#C8102E' }}>{item.time}</div>
              <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '9px', color: '#CCCCCC' }}>{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function FinanceMockup() {
  const kpis = [
    { label: 'Ingresos mes', value: '$2.4B', color: '#10B981' },
    { label: 'Margen bruto', value: '18.4%', color: '#C8102E' },
    { label: 'Capital inv.', value: '$8.1B', color: '#F59E0B' },
  ];
  const bars = [
    { cat: 'SUV', pct: 75, color: '#C8102E' },
    { cat: 'Pickup', pct: 55, color: '#F59E0B' },
    { cat: 'Can-Am', pct: 90, color: '#10B981' },
    { cat: 'Sea-Doo', pct: 40, color: '#3B82F6' },
  ];
  return (
    <div style={{ background: '#111111', borderRadius: '10px', padding: '16px', borderTop: '3px solid #C8102E' }}>
      <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '11px', color: '#C8102E', letterSpacing: '0.1em', marginBottom: '12px' }}>DASHBOARD FINANCIERO</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', marginBottom: '12px' }}>
        {kpis.map((kpi) => (
          <div key={kpi.label} style={{ background: '#1A1A1A', borderRadius: '6px', padding: '10px', textAlign: 'center' }}>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 800, fontSize: '14px', color: kpi.color }}>{kpi.value}</div>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '8px', color: '#888888', marginTop: '2px' }}>{kpi.label}</div>
          </div>
        ))}
      </div>
      <div style={{ background: '#1A1A1A', borderRadius: '6px', padding: '10px' }}>
        <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '9px', color: '#888888', textTransform: 'uppercase', marginBottom: '8px' }}>Margen por categoría</div>
        {bars.map((bar) => (
          <div key={bar.cat} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
            <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 600, fontSize: '9px', color: '#CCCCCC', width: '45px' }}>{bar.cat}</span>
            <div style={{ flex: 1, height: '6px', background: '#2A2A2A', borderRadius: '3px' }}>
              <div style={{ width: `${bar.pct}%`, height: '100%', background: bar.color, borderRadius: '3px' }} />
            </div>
            <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '9px', color: bar.color, width: '28px', textAlign: 'right' }}>{bar.pct}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function PDFMockup() {
  return (
    <div style={{ background: '#FFFFFF', borderRadius: '10px', padding: '16px', borderTop: '3px solid #C8102E' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <div>
          <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 900, fontSize: '14px', color: '#0A0A0A', letterSpacing: '0.08em' }}>DriveX</div>
          <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '8px', color: '#888888' }}>FICHA TÉCNICA</div>
        </div>
        <div style={{ background: '#C8102E', color: '#FFF', fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '8px', padding: '3px 8px', borderRadius: '3px' }}>PDF</div>
      </div>
      <div style={{ height: '60px', background: '#E5E5E5', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
        <span style={{ color: '#888888', fontSize: '10px', fontFamily: 'Montserrat, sans-serif' }}>📷 Foto del vehículo</span>
      </div>
      <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '12px', color: '#0A0A0A', marginBottom: '8px' }}>Porsche Cayenne S 2024</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px' }}>
        {[['Motor', '2.9L Biturbo V6'], ['Potencia', '434 hp'], ['Combustible', 'Gasolina'], ['Tracción', 'AWD']].map(([k, v]) => (
          <div key={k} style={{ background: '#F5F5F5', borderRadius: '3px', padding: '5px 7px' }}>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '7px', color: '#888888' }}>{k}</div>
            <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '9px', color: '#0A0A0A' }}>{v}</div>
          </div>
        ))}
      </div>
      <div style={{ background: '#0A0A0A', borderRadius: '4px', padding: '6px 8px', marginTop: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '10px', color: '#C8102E' }}>$890.000.000 COP</span>
        <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '8px', color: '#888888' }}>+57 300 000 0000</span>
      </div>
    </div>
  );
}

const mockupMap: Record<string, React.ReactNode> = {
  catalog: <CatalogMockup />,
  pipeline: <PipelineMockup />,
  crm: <CRMMockup />,
  finance: <FinanceMockup />,
  pdf: <PDFMockup />,
};

export default function DriveXFeatures() {
  const [activeTab, setActiveTab] = useState(0);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const tab = tabs[activeTab];

  return (
    <section
      id="caracteristicas"
      ref={sectionRef}
      className="dx-font"
      style={{ background: '#FFFFFF', padding: '100px 0' }}
    >
      <div className="max-w-6xl mx-auto px-6">
        {/* Eyebrow + Headline */}
        <div className="text-center mb-12" style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(28px)', transition: 'opacity 0.6s ease, transform 0.6s ease' }}>
          <div style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '10px', color: '#C8102E', letterSpacing: '0.25em', textTransform: 'uppercase', marginBottom: '16px' }}>
            UNA PLATAFORMA. TODO LO QUE NECESITAS.
          </div>
          <h2 style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 900, fontSize: 'clamp(32px, 4.5vw, 52px)', color: '#0A0A0A', letterSpacing: '-0.02em' }}>
            Del catálogo a las finanzas,<br />sin salir de DriveX.
          </h2>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-10" style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.6s ease 0.2s' }}>
          {tabs.map((t, i) => (
            <button
              key={t.id}
              onClick={() => setActiveTab(i)}
              style={{
                fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '12px',
                letterSpacing: '0.08em', textTransform: 'uppercase', padding: '10px 20px',
                borderRadius: '20px', border: 'none', cursor: 'pointer',
                background: activeTab === i ? '#C8102E' : '#E5E5E5',
                color: activeTab === i ? '#FFFFFF' : '#555555',
                transition: 'all 0.2s ease',
              }}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Tab content */}
        <div
          className="grid grid-cols-1 md:grid-cols-5 gap-10 items-center"
          style={{ opacity: visible ? 1 : 0, transition: 'opacity 0.2s ease' }}
        >
          {/* Left — text */}
          <div className="md:col-span-2">
            <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '10px', color: tab.tagColor, background: tab.tagBg, padding: '4px 10px', borderRadius: '20px', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
              {tab.tag}
            </span>
            <h3 style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 800, fontSize: '22px', color: '#0A0A0A', marginTop: '16px', marginBottom: '12px', lineHeight: 1.3 }}>
              {tab.h3}
            </h3>
            <p style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400, fontSize: '14px', color: '#555555', lineHeight: 1.7, marginBottom: '16px' }}>
              {tab.body}
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 20px 0' }}>
              {tab.bullets.map((b) => (
                <li key={b} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '8px' }}>
                  <span style={{ color: '#C8102E', fontWeight: 700, fontSize: '14px', marginTop: '1px', flexShrink: 0 }}>✓</span>
                  <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 500, fontSize: '13px', color: '#555555' }}>{b}</span>
                </li>
              ))}
            </ul>
            <button
              onClick={() => scrollTo(tab.ctaTarget)}
              style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: '12px', color: '#C8102E', background: 'transparent', border: '1px solid #C8102E', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer', letterSpacing: '0.08em', textTransform: 'uppercase' }}
              onMouseEnter={e => ((e.currentTarget as HTMLElement).style.background = 'rgba(200,16,46,0.06)')}
              onMouseLeave={e => ((e.currentTarget as HTMLElement).style.background = 'transparent')}
            >
              {tab.cta}
            </button>
          </div>

          {/* Right — mockup */}
          <div className="md:col-span-3">
            {mockupMap[tab.mockup]}
          </div>
        </div>
      </div>
    </section>
  );
}
